import http from "../plugins/Axios";
import { makerPagination } from "@/utils/pureFunctions";

export default {
  actions: {
    async getProductsWithAttributes(_, query) {
      try {
        let {
          data: { data, total },
        } = await http.get("/product/get-items-with-attribute");
        data = data.map((item, index) => {
          item.index = index + 1;
          item.show = true;
          item.attribute =
            item.attributes && item.attributes.length && item.attributes[0];
          item.children = item.attributes.slice(1) || [];
          return item;
        });
        return {
          data,
          lastPage: query ? Math.ceil(total / query.limit) : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getProducts(_, query) {
      try {
        const params = query || {};
        const {
          data: { data: dataProduct, total },
        } = await http.get("product/get-items", {
          params,
        });
        let data = dataProduct.map((item, index) => {
          item.index = index + 1;
          return item;
        });
        return {
          data,
          total,
          lastPage: params.limit
            ? makerPagination({ limit: params.limit, total }).lastPage
            : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async getProductsByWarehouseId(_, query) {
      try {
        const params = query || {};
        const {
          data: { data: dataProduct, total },
        } = await http.get("product/by-warehouse", {
          params,
        });
        let data = dataProduct.map((item, index) => {
          item.index = index + 1;
          return item;
        });
        return {
          data,
          total,
          lastPage: params.limit
            ? makerPagination({ limit: params.limit, total }).lastPage
            : null,
        };
      } catch (e) {
        return Promise.reject(e);
      }
    },

    async saveProduct(_, payload) {
      try {
        const {
          data: { data },
        } = await http.post("product/save", payload);
        return data;
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async deleteProduct(_, id) {
      try {
        await http.delete(`/product/delete?id=${id}`);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
